import React from 'react';
import {CircularProgress} from '@material-ui/core';
import {Text} from 'components/core';
import {ChatItem, ChatDate} from './ChatItem.js';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import { Forum } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    centered: {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    empty: {
        display: "flex",
        flexDirection: "column",
        '& $icon':
        {
            opacity: 0.2,
            width: 150,
            height: 150
        }
    },
    icon: {}
}), {name: "RaymanChatMessages"});

function ChatMessages({messages, loading, channelID, userToTheRight, className})
{
    const scrollRef = React.useRef(null);
    const scrollWasAtBottomBeforeMessage = React.useRef(true);
    const classes = useStyles();

    let messageItemsList = React.useMemo(() => {
        
        if(scrollRef.current) scrollWasAtBottomBeforeMessage.current = Math.ceil(scrollRef.current.clientHeight + scrollRef.current.scrollTop) >= scrollRef.current.scrollHeight;
        console.log("redrawing messages");
        let messageItemsList = [];
        if(messages && messages.length > 0)
        {
            let lastDate = new Date(messages[messages.length -1].datetime);
            let lastUser = null;
            messageItemsList.push(<ChatDate key={lastDate.toLocaleDateString()}>{lastDate.toLocaleDateString()}</ChatDate>);
            for(let i = messages.length -1;i>=0; i--)
            {
                let chatDate = new Date(messages[i].datetime);
                if(chatDate.getDate() !== lastDate.getDate() ||
                   chatDate.getMonth() !== lastDate.getMonth() ||
                   chatDate.getYear() !== lastDate.getYear() )
                {
                    lastDate = chatDate;
                    messageItemsList.push(<ChatDate key={lastDate.toLocaleDateString()}>{chatDate.toLocaleDateString()}</ChatDate>);
                }
                let grouped = false;
                if(messages[i].fromUser === lastUser) grouped = true;
                lastUser = messages[i].fromUser;
                messageItemsList.push(<ChatItem 
                    channelID={channelID}
                    message={messages[i]}
                    position={userToTheRight === messages[i].fromUser ? "right" : "left"}
                    showReadState={(userToTheRight === messages[i].fromUser)}
                    key={messages[i].messageID}
                    grouped={grouped}
                />);
            }
        }
        return messageItemsList;
    }, [messages, channelID, userToTheRight, scrollRef]);    

    React.useEffect(() => {
        let scrollContainer = scrollRef.current;
        let atBottom = Math.ceil(scrollContainer.clientHeight + scrollContainer.scrollTop) >= scrollContainer.scrollHeight;

        // if old value is different than new, a new message has been added, scroll with smoothing
        if(scrollWasAtBottomBeforeMessage.current && !atBottom)
        {
            scrollContainer.scrollTo({top: scrollContainer.scrollHeight - scrollContainer.clientHeight, behavior: "smooth"});
        }
        let rsobserver = new ResizeObserver(() => {
            if(atBottom && scrollWasAtBottomBeforeMessage.current)
            {
                scrollContainer.scrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;
            }
        });

        let mtobserver = new MutationObserver(() => {
            if(atBottom && scrollWasAtBottomBeforeMessage.current)
            {
                scrollContainer.scrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;
            }
        });
    
        if(scrollContainer)
        {
            rsobserver.observe(scrollContainer);
            mtobserver.observe(scrollContainer, {subtree: true, childList: true})
        }
        return () => {
            if(scrollContainer)
            {
                rsobserver.unobserve(scrollContainer);
                mtobserver.disconnect();
            }
        }

    }, [messageItemsList, scrollRef]);

    
    return <div className={className} ref={scrollRef} id="scrollable"> 
            {loading  ? 
                <div className={classes.centered}>
                <CircularProgress />
                </div>
            :
                messageItemsList.length > 0 ? 
                    messageItemsList
                :
                <div className={clsx(classes.centered, classes.empty)}>
                    <Forum className={classes.icon} /><br />
                    <Text title>Todavía no hay mensajes</Text>
                    <Text>¡Escribe algo!</Text>
                </div>
            }
    </div>
}

export default ChatMessages;